import { render, staticRenderFns } from "./ListSalesContract.vue?vue&type=template&id=98e96e78&"
import script from "./ListSalesContract.vue?vue&type=script&lang=js&"
export * from "./ListSalesContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports